const base = require('core/product/detail');
const yotpo = require('../components/yotpo');

const $body = $('body');

/**
 * Init handlers for updating the product specifications tab when a variant is changed
 */
base.customAfterAttributeSelect = function () {
    $body.on('product:afterAttributeSelect', function(e, response) {
        if (response.data.product.guitarSpecificationsHtml) {
            $('.guitar-specifications').replaceWith(response.data.product.guitarSpecificationsHtml);
        }

        if (typeof lcly_reload_0 !== "undefined") {
            lcly_reload_0({ 'upc' : response.data.product.UPC });
        }

        $body.find('.ps-widget').attr('ps-sku', response.data.product.id);
        window.PriceSpider.rebind();

        base.toggleSpecificationBtnText();

        var $qtyCartContainer = response.container.find('.qty-cart-container');
        if ($qtyCartContainer) {
            $qtyCartContainer.each(function () {
                if (!response.data.product.available) {
                    $(this).find('.quantity').addClass('d-none');
                }
            });
        }

        var $addToCartContainer = response.container.find('.addtocartbutton');
        
        // If hideBuyButton is enabled, hide the BISN form as well.
        if (response.data.product.hideBuyButton) {
            $('.bisnform').addClass('d-none');
        }

        if (response.data.product.hideBuyButton || response.data.product.showBISN) {
            $addToCartContainer.addClass('d-none');
        } else {
            $addToCartContainer.removeClass('d-none');
            var $addToCartBtn = response.container.find('.add-to-cart');
            if(response.data.product.available && response.data.product.readyToOrder) {
                $addToCartBtn.text($addToCartBtn.data('instock'));
            } else {
                $addToCartBtn.text($addToCartBtn.data('outofstock'));
            }
        }
    });
}

/**
 * Init handler for updating the "Load More" button text depending on the collapse state
 */
base.toggleSpecificationBtnText = function () {
    const $collapseSpecs = $('#collapseSpecs');

    $collapseSpecs.on('hidden.bs.collapse', function () {
        const $btn = $('.js-load-more');

        $btn.text($btn.data('showText'));
    });

    $collapseSpecs.on('shown.bs.collapse', function () {
        const $btn = $('.js-load-more');

        $btn.text($btn.data('hideText'));
    })
}

/**
 * Update the price spider widget with the correct product ID after it has been changed
 */
base.updatePriceSpider = function() {
    const psJQObj = $body.find('.ps-widget');
    psJQObj.parent().hide();

    const psMut = document.getElementById('ps-widget');

    if (psMut) {
        let prevClassState = psMut.classList.contains('ps-enabled');
        const psMutationObserver = new MutationObserver(psCallBack);

        psMutationObserver.observe(psMut, { attributes: true });

        const fdb = $body.find('.find-a-dealer');
        fdb.addClass('text-left');

        function psCallBack(mutationsList) {
            mutationsList.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    const currentClassState = mutation.target.classList.contains('ps-enabled');

                    if (prevClassState !== currentClassState) {
                        prevClassState = currentClassState;

                        if(currentClassState){
                            psJQObj.parent().show();
                        }else{
                            psJQObj.parent().hide();
                        }
                    }
                }
            });
        }
    }
};

/**
 * Iniitialize yotpo on the PDP
 */
base.initYotpo = yotpo.methods.initYotpoPDP;

module.exports = base;
